import {stateChangeNestedValue} from "@Common/react/state-change-nested-value";
import {chain}                  from "@Common/utils/fs";
import {parseUrlQuery}          from "@Common/utils/parse-url-query";

import {formatDate} from "../../../../../../common/calendar-ui/format-date";
import {TagsInput}  from "../tags-input/tags-input";

export const OmniSearch = ({
        onAdvanceOpen=undefined,
        tags,
        freeText,
        domRef = undefined,
}) => TagsInput({
    onEnter: () => {
        if (freeText.value !== "") {
            tags.onChange({...tags.value, all: [...tags.value.all, freeText.value]});
            freeText.onChange("");
        } else {
            tags.onChange(tags.value);
        }
    },
    tags: [
        ...chain(
            Object.keys(tags.value).filter((k) => k !== "all" && tags.value[k] != null),
            (keys) => keys.map((k) => ({
                label: k === "startDate" || k === "endDate" ? (
                    formatDate(tags.value[k])
                ) : (
                    tags.value[k]
                ),
                onRemove: () => {
                    window.history.pushState(null, '', window.location.pathname)
                    stateChangeNestedValue(tags, [k], () => null);
                },
            })),
        ),
        ...tags.value.all.map((freeText, i) => ({
            label: freeText,
            onRemove: () => {
                window.history.pushState(null, '', window.location.pathname)
                stateChangeNestedValue(tags, ["all"], (_) => _.filter((tag, j) => j !== i))
            },
        })),
    ],
    freeText,
    className: "omni-search",
    onCreateTag: (text) => {
        tags.onChange({...tags.value, all: [...tags.value.all, text]});
    },
    onClearAll: () => {
        tags.onChange({
            all: [],
            orderName: null,
            orderId: null,
            cartId: null,
            poNumber: null,
            startDate: null,
            endDate: null,
        });
        freeText.onChange("");
    },
    onAdvanceOpen,
    domRef,
});
